<template>
    <div>
        <div class="row">
            <div class="page-breadcrumb d-flex justify-content-between">
                <h2 class="page-title">
                    <i class="fas fa-tasks"></i> {{ $t("lang.label_dashboar") }}
                </h2>
            </div>
        </div>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import axios from "axios";
export default {
    name: "Dimenu",
    data () {
        return {
            isLoading: false,
        };
    },
};
</script>
